import React from 'react';
import Advert from './component';

export default React.memo(Advert);
